import Actions from '../../odata/actions';

const actions = new Actions('checklist', 'checklists');

export default actions;
